var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeProjectionThumbnail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 170,
    viewBox: "0 0 230 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12458_87340",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 230,
    height: 170
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0 2.23858 2.23858 0 5 0H225C227.761 0 230 2.23858 230 5V170H0V5Z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0 2.23858 2.23858 0 5 0H225C227.761 0 230 2.23858 230 5V170H0V5Z",
    fill: "url(#paint0_linear_12458_87340)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12458_87340)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10C14.6863 10 12 12.6863 12 16V154C12 157.314 14.6863 160 18 160H212C215.314 160 218 157.314 218 154V16C218 12.6863 215.314 10 212 10H18Z",
    fill: "#F3F3F3",
    stroke: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76 40C74.8954 40 74 40.8954 74 42V45C74 46.1046 74.8954 47 76 47H192C193.105 47 194 46.1046 194 45V42C194 40.8954 193.105 40 192 40H76Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76 40C74.8954 40 74 40.8954 74 42V45C74 46.1046 74.8954 47 76 47H172C173.105 47 174 46.1046 174 45V42C174 40.8954 173.105 40 172 40H76Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 38.5C32.8954 38.5 32 39.3954 32 40.5V46.5C32 47.6046 32.8954 48.5 34 48.5H60C61.1046 48.5 62 47.6046 62 46.5V40.5C62 39.3954 61.1046 38.5 60 38.5H34Z",
    fill: "#DFE0E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76 68C74.8954 68 74 68.8954 74 70V73C74 74.1046 74.8954 75 76 75H192C193.105 75 194 74.1046 194 73V70C194 68.8954 193.105 68 192 68H76Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76 68C74.8954 68 74 68.8954 74 70V73C74 74.1046 74.8954 75 76 75H148C149.105 75 150 74.1046 150 73V70C150 68.8954 149.105 68 148 68H76Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 66.5C32.8954 66.5 32 67.3954 32 68.5V74.5C32 75.6046 32.8954 76.5 34 76.5H60C61.1046 76.5 62 75.6046 62 74.5V68.5C62 67.3954 61.1046 66.5 60 66.5H34Z",
    fill: "#DFE0E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76 96C74.8954 96 74 96.8954 74 98V101C74 102.105 74.8954 103 76 103H192C193.105 103 194 102.105 194 101V98C194 96.8954 193.105 96 192 96H76Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76 96C74.8954 96 74 96.8954 74 98V101C74 102.105 74.8954 103 76 103H118.624C119.729 103 120.624 102.105 120.624 101V98C120.624 96.8954 119.729 96 118.624 96H76Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 94.5C32.8954 94.5 32 95.3954 32 96.5V102.5C32 103.605 32.8954 104.5 34 104.5H60C61.1046 104.5 62 103.605 62 102.5V96.5C62 95.3954 61.1046 94.5 60 94.5H34Z",
    fill: "#DFE0E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76 124C74.8954 124 74 124.895 74 126V129C74 130.105 74.8954 131 76 131H192C193.105 131 194 130.105 194 129V126C194 124.895 193.105 124 192 124H76Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76 124C74.8954 124 74 124.895 74 126V129C74 130.105 74.8954 131 76 131H98.1194C99.224 131 100.119 130.105 100.119 129V126C100.119 124.895 99.224 124 98.1194 124H76Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 122.5C32.8954 122.5 32 123.395 32 124.5V130.5C32 131.605 32.8954 132.5 34 132.5H60C61.1046 132.5 62 131.605 62 130.5V124.5C62 123.395 61.1046 122.5 60 122.5H34Z",
    fill: "#DFE0E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12458_87340",
    x1: 115,
    y1: 0,
    x2: 115,
    y2: 171.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeProjectionThumbnail);
export default __webpack_public_path__ + "static/media/time-projection-thumbnail.b8c4b0b2f49d6c3b1c16454d6496758d.svg";
export { ForwardRef as ReactComponent };